import { Injectable } from "@angular/core";

import { mapTo } from "rxjs/operators";

import { InstallationHttpClient, ParametreForAktuelleInstallation } from "@e-forsyning/common/http";

import { ILoginoplysninger } from "./model/loginoplysninger.model";

@Injectable({ providedIn: "root" })
export class LoginoplysningerRepository {
    constructor(private readonly http: InstallationHttpClient) {}

    public redigerLoginoplysninger(loginoplysninger: ILoginoplysninger): Promise<void> {
        const info = {
            soldPwd: loginoplysninger.nuvaerendeKodeord,
            saltedPwd: loginoplysninger.nytKodeord,
            eBrugerId: loginoplysninger.brugerId
        };

        return this.http.postWithStringResult("api/updatepwd", info, ParametreForAktuelleInstallation.true).pipe(mapTo(null)).toPromise();
    }
}
